import { render, staticRenderFns } from "./ResultadosEvaluacion.vue?vue&type=template&id=55c4333d&scoped=true"
import script from "./ResultadosEvaluacion.vue?vue&type=script&lang=js"
export * from "./ResultadosEvaluacion.vue?vue&type=script&lang=js"
import style0 from "./ResultadosEvaluacion.vue?vue&type=style&index=0&id=55c4333d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c4333d",
  null
  
)

export default component.exports